import React, { useEffect, useState } from 'react';
import { money, statusBadge } from '../utils/order';

import AuthService from '../services/auth.service';
import { Link } from 'react-router-dom';
import OrderService from '../services/order.service';
import Spinner from './Spinner';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const Orders = () => {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  // Staff (moderator/admin) get a shortcut to the order management page.
  const currentUser = AuthService.getCurrentUser();
  const roles = (currentUser && currentUser.roles) || [];
  const isStaff = roles.includes('ROLE_MODERATOR') || roles.includes('ROLE_ADMIN');

  const load = () => {
    setLoading(true);
    OrderService.myOrders()
      .then((res) => setOrders(res.data))
      .catch((err) => toast.error((err.response && err.response.data && err.response.data.message) || err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  if (loading) {
    return (
      <Spinner />
    );
  }

  return (
    <div className='container mt-4'>
      <div className='d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3'>
        <h3 className='mb-0'>{t('orders.title')}</h3>
        {isStaff && (
          <Link to='/manage-orders' className='btn btn-default border'>
            {t('orders.manageOrders', 'Manage orders')} →
          </Link>
        )}
      </div>

      {orders.length === 0 ? (
        <div>
          <p className='text-muted'>{t('orders.empty')}</p>
          <Link to='/catalog' className='btn btn-primary'>
            {t('orders.browseProducts')}
          </Link>
        </div>
      ) : (
        <div className='table-responsive rounded'>
          <table className='table table-hover align-middle'>
            <thead>
              <tr>
                <th style={{ width: 70 }}>#</th>
                <th>{t('orders.date')}</th>
                <th>{t('orders.items')}</th>
                <th style={{ width: 130 }}>{t('orders.total')}</th>
                <th style={{ width: 120 }}>{t('orders.status')}</th>
                <th style={{ width: 90 }}></th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => {
                const meta = statusBadge(o.status);
                return (
                  <tr key={o.id}>
                    <td>{o.id}</td>
                    <td>{new Date(o.createdAt).toLocaleString()}</td>
                    <td>{(o.items || []).reduce((n, it) => n + it.quantity, 0)}</td>
                    <td className='fw-bold'>{money(o.total_amount)}</td>
                    <td>
                      <span className={`badge ${meta.cls}`}>{t(`orderStatus.${o.status}`, meta.label)}</span>
                    </td>
                    <td>
                      <Link to={`/orders/${o.id}`} className='btn btn-sm btn-outline-primary'>
                        {t('orders.view')}
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Orders;
